
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2475',
  depVersions: {
  "customer-portal-app": "static-1.2475",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.476",
  "data-fetching-client": "static-1.9717",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25526",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5644",
  "hs-test-utils": "static-1.8069",
  "hub-http": "static-1.6275",
  "hub-http-shared-msw-handlers": "static-1.10088",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18374",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11526",
  "I18n": "static-7.1633",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6516",
  "payment-link-components": "static-1.23648",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7095",
  "quartz-core": "static-1.6314",
  "quartz-i18n": "static-1.770",
  "react": "static-7.187",
  "react-colorpicker": "static-2.10261",
  "react-dlb": "static-1.80",
  "react-utils": "static-2.5384",
  "rich-text-lib": "static-1.19919",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18070",
  "ui-components-test-utils": "static-1.5663",
  "UIComponents": "static-3.8472",
  "foundations-assets": "static-1.4922",
  "foundations-components": "static-1.8032",
  "foundations-theming": "static-1.4477",
  "foundations-theming-specialty": "static-1.2193",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1017",
  "quartz-config": "static-1.873",
  "quartz-routing": "static-1.525",
  "quick-fetch": "static-1.3958",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16731",
  "rpc-client-utils": "static-1.4705",
  "sanitize-text": "static-1.8195",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4815",
  "ui-addon-react-router-dom": "static-1.9594",
  "usage-tracker": "static-1.7402",
  "usage-tracker-anonymous": "static-1.5819",
  "usage-tracker-core": "static-1.7252",
  "video-components-external": "static-1.11460",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3440",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3372",
  "quartz-webpack": "static-1.3319",
  "bend-plugin-quartz-routing": "static-1.173",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7730",
  "frontend-preferences-client": "static-1.7979",
  "laboratory-lib": "static-3.7208",
  "onboarding-scopes": "static-1.6514",
  "seat-types-lib": "static-1.139",
  "ui-addon-opt": "static-4.8415",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3180",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.121",
  "ts-schema": "static-1.4120",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7832",
  "cssUtils": "static-1.804",
  "customer-data-ui-utilities": "static-1.9878",
  "HubStyle": "static-2.11833",
  "knowledge-content-types": "static-1.8517",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.488",
  "ui-addon-emoji-picker": "static-1.9939",
  "ui-addon-i18n": "static-1.11204",
  "ui-business-units-lib": "static-1.9110",
  "ui-shepherd-react": "static-3.10264",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4378",
  "commerce-tours-lib": "static-1.6198",
  "customer-data-properties": "static-1.51753",
  "getting-started-shared-tasks": "static-1.18569",
  "growth-onboarding-reliability": "static-1.5133",
  "onboarding-tours": "static-1.16702",
  "reference-resolvers-lite": "static-1.8150",
  "sales-checkout-service-client": "static-1.3689",
  "ui-addon-iframeable": "static-1.9113",
  "user-context": "static-1.5160",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4691",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.770",
  "quartz-head": "static-1.760",
  "quartz-test": "static-1.770",
  "quartz-tracking": "static-1.474",
  "trellis-components": "static-1.2095",
  "ui-fonts": "static-1.788",
  "usage-tracker-container": "static-1.7392",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9476",
  "data-token-picker": "static-1.16497",
  "FileManagerLib": "static-1.39397",
  "property-translator": "static-1.5451",
  "atom": "static-1.5127",
  "merchandise-lib": "static-1.265",
  "purchase-motions-components": "static-1.6008",
  "salesImages": "static-1.526",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5515",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1165",
  "bend-plugin-foundations-components": "static-1.4301",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "trellis-assets": "static-1.2076",
  "bend-plugin-foundations-theming": "static-1.2960",
  "foundations-theming-base": "static-1.3462",
  "stylex": "static-1.34",
  "interframe": "static-3.4812",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5816",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.115",
  "chirp-fetch": "static-1.1940",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4529",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4704",
  "content-media-composition-data-lib": "static-1.12529",
  "content-media-compositions": "static-2.16536",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4206",
  "magpie-lib": "static-1.5586",
  "magpie-types": "static-1.5046",
  "media-bridge-lib": "static-1.19017",
  "video-data-lib": "static-1.35118",
  "bender-build-tools": "static-1.3254",
  "inbound-db-properties-service-client": "static-1.3886",
  "superstore": "static-1.4813",
  "feedback-loader": "static-1.29392",
  "ai-components-ui-library": "static-1.9098",
  "ui-addon-video-player": "static-1.8756",
  "ui-coaching-tips": "static-1.28705",
  "sassPrefix": "static-1.157",
  "react-dnd-compat": "static-1.4666",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2551",
  "navigation-messaging": "static-1.7493",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8224",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9751",
  "crm-message-bus": "static-1.43105",
  "growth-data-modal": "static-1.5509",
  "hubspot-apollo-client": "static-1.4930",
  "onboarding-tours-client": "static-1.4916",
  "calling-global-api": "static-1.64698",
  "calling-internal-common": "static-1.31357",
  "calling-lifecycle-internal": "static-1.66080",
  "calling-lifecycle-messages": "static-1.58374",
  "conditional-properties-service-client": "static-1.3838",
  "crm-links": "static-1.6359",
  "crm-pipelines-api-client-types": "static-1.4180",
  "customer-data-objects-ui-components": "static-1.13085",
  "customer-data-properties-shared-msw-handlers": "static-1.9415",
  "customer-data-property-utils": "static-1.8145",
  "external-options-client-types": "static-1.4199",
  "file-manager-components": "static-1.23757",
  "framework-data-schema-resolvers": "static-1.6941",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.221",
  "inbound-db-meta-service-client": "static-1.3626",
  "inbounddb-objects-service-types": "static-1.4263",
  "meetings-icalendar-utils-lib": "static-1.685",
  "multi-currency-client-types": "static-1.3732",
  "object-builder-ui-client": "static-1.48924",
  "pipeline-validation-client-types": "static-1.4006",
  "property-value-citations": "static-1.2367",
  "pulse": "static-1.639",
  "smart-property-lib": "static-1.7380",
  "tiered-pricing": "static-1.1333",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11042",
  "growth-onboarding-confetti": "static-1.3119",
  "growth-onboarding-next-action-utils": "static-1.2069",
  "navigation-components": "static-1.18166",
  "onboarding-tours-utils": "static-1.768",
  "ui-shepherd-tracker": "static-1.7645",
  "ui-universal-auth": "static-1.9042",
  "batch-promise": "static-1.1594",
  "getting-started-shared-tasks-store": "static-1.17687",
  "hubspotter-http-shared-msw-handlers": "static-1.10086",
  "usage-tracker-session-replay": "static-1.5088",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.986",
  "tanstack-virtual": "static-1.31",
  "audio-components": "static-1.5993",
  "FileManagerCore": "static-1.39256",
  "FileManagerImages": "static-1.36908",
  "video-components": "static-1.13462",
  "foundations-components-legacy": "static-1.1057",
  "purchase-motions-api": "static-1.6011",
  "signup-constants": "static-1.18953",
  "signup-ui-url-generator": "static-2.8106",
  "usage-tracker-public": "static-1.7213",
  "reactive-lib": "static-1.776",
  "simple-logging-lib": "static-1.3103",
  "chatspot-core": "static-1.21526",
  "ContentUtils": "static-1.68516",
  "copilot-toolkit": "static-1.11273",
  "growth-onboarding-feedback-components": "static-1.6632",
  "commerce-permissions": "static-1.827",
  "customer-data-tracking": "static-1.6942",
  "products-iframe-lib": "static-1.8078",
  "products-ui-components-shared-msw-handlers": "static-1.10470",
  "restore-request-side-panel-lib": "static-1.1032",
  "onboarding-data-sync-lib": "static-1.2045",
  "hubspot-apollo-cache": "static-1.389",
  "calling-error-reporting": "static-1.31364",
  "shared-worker-versioning": "static-1.11089",
  "calling-usage-tracker": "static-1.6594",
  "self-service-api": "static-1.10300",
  "voice-sms-access-library": "static-1.1209",
  "conversations-skeleton-state": "static-1.7301",
  "location-customization-utils-lib": "static-1.9410",
  "fdsr-migration-layer": "static-1.60",
  "framework-builder-read-service-client": "static-1.4045",
  "framework-data-schema-quick-fetch": "static-1.6846",
  "persist-promise": "static-1.3751",
  "event-emitter": "static-1.1000",
  "bend-plugin-pulse": "static-1.142",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.276",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10171",
  "fsm": "static-1.3783",
  "policy-lib": "static-1.6830",
  "react-tinymce": "static-1.55387",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10234",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54513",
  "tinymce-plugins": "static-1.57627",
  "tinymce-themes": "static-1.56483",
  "growth-onboarding-next-action-components": "static-1.2097",
  "user-context-client": "static-1.4655",
  "nest": "static-1.284",
  "unified-auth-core-lib": "static-1.838",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4590",
  "video-embed": "static-1.35952",
  "content-icons-ui": "static-1.2239",
  "social-insights-client-types": "static-1.22239",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4865",
  "integrations-lib": "static-1.16331",
  "underscore": "static-1.8",
  "breeze-engine-lib": "static-1.838",
  "sales-views-client-types": "static-1.4310",
  "InboxConnectUtils": "static-4.14954",
  "meetings-connect-utils-lib": "static-1.7657",
  "calling-orchestration-schema": "static-1.35986",
  "crm-record-cards-service-types": "static-1.3630",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4566",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3094",
  "tinymce-data": "static-1.40598",
  "ui-addon-sales-email": "static-1.5263",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12546",
  "layout-dnd-utils": "static-1.11521",
  "react-codemirror": "static-1.10680",
  "ui-brand-identity-lib": "static-1.15483",
  "NamespacedHubStyle": "static-2.9099",
  "outpost": "static-1.4228",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13746",
  "integrations-tracking-lib": "static-1.5658",
  "native-integrations-shared-strings": "static-1.7834",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10417",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.556",
  "breeze-engine-core": "static-1.116",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68591",
  "layout-data-lib": "static-1.9846",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3070",
  "ads-unified-auth-lib": "static-1.41",
  "google-sheets-integration-lib": "static-1.387",
  "microsoft-drive-integration-lib": "static-1.523",
  "slack-ui-library": "static-1.10444",
  "advanced-menus-core": "static-1.15210",
  "advanced-menus-lib": "static-1.12145",
  "ExportDialog": "static-6.10438",
  "ui-memberships-settings-lib": "static-1.34187",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15209",
  "simple-menus-lib": "static-1.16726"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2475",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.476",
  "data-fetching-client": "/data-fetching-client/static-1.9717",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25526",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5644",
  "hs-test-utils": "/hs-test-utils/static-1.8069",
  "hub-http": "/hub-http/static-1.6275",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10088",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18374",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11526",
  "I18n": "/I18n/static-7.1633",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6516",
  "payment-link-components": "/payment-link-components/static-1.23648",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7095",
  "quartz-core": "/quartz-core/static-1.6314",
  "quartz-i18n": "/quartz-i18n/static-1.770",
  "react": "/react/static-7.187",
  "react-colorpicker": "/react-colorpicker/static-2.10261",
  "react-dlb": "/react-dlb/static-1.80",
  "react-utils": "/react-utils/static-2.5384",
  "rich-text-lib": "/rich-text-lib/static-1.19919",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18070",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5663",
  "UIComponents": "/UIComponents/static-3.8472",
  "foundations-assets": "/foundations-assets/static-1.4922",
  "foundations-components": "/foundations-components/static-1.8032",
  "foundations-theming": "/foundations-theming/static-1.4477",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2193",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1017",
  "quartz-config": "/quartz-config/static-1.873",
  "quartz-routing": "/quartz-routing/static-1.525",
  "quick-fetch": "/quick-fetch/static-1.3958",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16731",
  "rpc-client-utils": "/rpc-client-utils/static-1.4705",
  "sanitize-text": "/sanitize-text/static-1.8195",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4815",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9594",
  "usage-tracker": "/usage-tracker/static-1.7402",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5819",
  "usage-tracker-core": "/usage-tracker-core/static-1.7252",
  "video-components-external": "/video-components-external/static-1.11460",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3440",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3372",
  "quartz-webpack": "/quartz-webpack/static-1.3319",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.173",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7730",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7979",
  "laboratory-lib": "/laboratory-lib/static-3.7208",
  "onboarding-scopes": "/onboarding-scopes/static-1.6514",
  "seat-types-lib": "/seat-types-lib/static-1.139",
  "ui-addon-opt": "/ui-addon-opt/static-4.8415",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3180",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.121",
  "ts-schema": "/ts-schema/static-1.4120",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7832",
  "cssUtils": "/cssUtils/static-1.804",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9878",
  "HubStyle": "/HubStyle/static-2.11833",
  "knowledge-content-types": "/knowledge-content-types/static-1.8517",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9939",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11204",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9110",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10264",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4378",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6198",
  "customer-data-properties": "/customer-data-properties/static-1.51753",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18569",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5133",
  "onboarding-tours": "/onboarding-tours/static-1.16702",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8150",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9113",
  "user-context": "/user-context/static-1.5160",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4691",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.770",
  "quartz-head": "/quartz-head/static-1.760",
  "quartz-test": "/quartz-test/static-1.770",
  "quartz-tracking": "/quartz-tracking/static-1.474",
  "trellis-components": "/trellis-components/static-1.2095",
  "ui-fonts": "/ui-fonts/static-1.788",
  "usage-tracker-container": "/usage-tracker-container/static-1.7392",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9476",
  "data-token-picker": "/data-token-picker/static-1.16497",
  "FileManagerLib": "/FileManagerLib/static-1.39397",
  "property-translator": "/property-translator/static-1.5451",
  "atom": "/atom/static-1.5127",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "purchase-motions-components": "/purchase-motions-components/static-1.6008",
  "salesImages": "/salesImages/static-1.526",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5515",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1165",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4301",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "trellis-assets": "/trellis-assets/static-1.2076",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2960",
  "foundations-theming-base": "/foundations-theming-base/static-1.3462",
  "stylex": "/stylex/static-1.34",
  "interframe": "/interframe/static-3.4812",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5816",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.115",
  "chirp-fetch": "/chirp-fetch/static-1.1940",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4529",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4704",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12529",
  "content-media-compositions": "/content-media-compositions/static-2.16536",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4206",
  "magpie-lib": "/magpie-lib/static-1.5586",
  "magpie-types": "/magpie-types/static-1.5046",
  "media-bridge-lib": "/media-bridge-lib/static-1.19017",
  "video-data-lib": "/video-data-lib/static-1.35118",
  "bender-build-tools": "/bender-build-tools/static-1.3254",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3886",
  "superstore": "/superstore/static-1.4813",
  "feedback-loader": "/feedback-loader/static-1.29392",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9098",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8756",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28705",
  "sassPrefix": "/sassPrefix/static-1.157",
  "react-dnd-compat": "/react-dnd-compat/static-1.4666",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2551",
  "navigation-messaging": "/navigation-messaging/static-1.7493",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8224",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9751",
  "crm-message-bus": "/crm-message-bus/static-1.43105",
  "growth-data-modal": "/growth-data-modal/static-1.5509",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4930",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4916",
  "calling-global-api": "/calling-global-api/static-1.64698",
  "calling-internal-common": "/calling-internal-common/static-1.31357",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66080",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58374",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3838",
  "crm-links": "/crm-links/static-1.6359",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4180",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13085",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9415",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8145",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "file-manager-components": "/file-manager-components/static-1.23757",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6941",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.221",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3626",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4263",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.685",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3732",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48924",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4006",
  "property-value-citations": "/property-value-citations/static-1.2367",
  "pulse": "/pulse/static-1.639",
  "smart-property-lib": "/smart-property-lib/static-1.7380",
  "tiered-pricing": "/tiered-pricing/static-1.1333",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11042",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3119",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2069",
  "navigation-components": "/navigation-components/static-1.18166",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.768",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7645",
  "ui-universal-auth": "/ui-universal-auth/static-1.9042",
  "batch-promise": "/batch-promise/static-1.1594",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17687",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10086",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5088",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.986",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "audio-components": "/audio-components/static-1.5993",
  "FileManagerCore": "/FileManagerCore/static-1.39256",
  "FileManagerImages": "/FileManagerImages/static-1.36908",
  "video-components": "/video-components/static-1.13462",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1057",
  "purchase-motions-api": "/purchase-motions-api/static-1.6011",
  "signup-constants": "/signup-constants/static-1.18953",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8106",
  "usage-tracker-public": "/usage-tracker-public/static-1.7213",
  "reactive-lib": "/reactive-lib/static-1.776",
  "simple-logging-lib": "/simple-logging-lib/static-1.3103",
  "chatspot-core": "/chatspot-core/static-1.21526",
  "ContentUtils": "/ContentUtils/static-1.68516",
  "copilot-toolkit": "/copilot-toolkit/static-1.11273",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6632",
  "commerce-permissions": "/commerce-permissions/static-1.827",
  "customer-data-tracking": "/customer-data-tracking/static-1.6942",
  "products-iframe-lib": "/products-iframe-lib/static-1.8078",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10470",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1032",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2045",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.389",
  "calling-error-reporting": "/calling-error-reporting/static-1.31364",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11089",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6594",
  "self-service-api": "/self-service-api/static-1.10300",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1209",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7301",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9410",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.60",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4045",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6846",
  "persist-promise": "/persist-promise/static-1.3751",
  "event-emitter": "/event-emitter/static-1.1000",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.142",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.276",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10171",
  "fsm": "/fsm/static-1.3783",
  "policy-lib": "/policy-lib/static-1.6830",
  "react-tinymce": "/react-tinymce/static-1.55387",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10234",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54513",
  "tinymce-plugins": "/tinymce-plugins/static-1.57627",
  "tinymce-themes": "/tinymce-themes/static-1.56483",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2097",
  "user-context-client": "/user-context-client/static-1.4655",
  "nest": "/nest/static-1.284",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.838",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4590",
  "video-embed": "/video-embed/static-1.35952",
  "content-icons-ui": "/content-icons-ui/static-1.2239",
  "social-insights-client-types": "/social-insights-client-types/static-1.22239",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4865",
  "integrations-lib": "/integrations-lib/static-1.16331",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.838",
  "sales-views-client-types": "/sales-views-client-types/static-1.4310",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14954",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7657",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35986",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3630",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4566",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3094",
  "tinymce-data": "/tinymce-data/static-1.40598",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5263",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12546",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11521",
  "react-codemirror": "/react-codemirror/static-1.10680",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15483",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9099",
  "outpost": "/outpost/static-1.4228",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13746",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5658",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7834",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10417",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.556",
  "breeze-engine-core": "/breeze-engine-core/static-1.116",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68591",
  "layout-data-lib": "/layout-data-lib/static-1.9846",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3070",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.41",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.387",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.523",
  "slack-ui-library": "/slack-ui-library/static-1.10444",
  "advanced-menus-core": "/advanced-menus-core/static-1.15210",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12145",
  "ExportDialog": "/ExportDialog/static-6.10438",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34187",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15209",
  "simple-menus-lib": "/simple-menus-lib/static-1.16726"
}
};
